var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageHeader"},[_c('a-page-header',{staticClass:"page-header",attrs:{"title":_vm.title}},[_c('template',{slot:"extra"},[_vm._t("button")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }